<template>
  <div class="section-content section4">
    <div class="content-wrapper">
      <div class="grid-container">
        <div class="grid-item" :class="{'animate__show': isActive}">
          <img src="../assets/glasses-detail1.png" alt="Glasses Detail">
        </div>
        <div class="grid-item" :class="{'animate__show': isActive}">
          <img src="../assets/glasses-model1.png" alt="Model with Glasses">
        </div>
        <div class="grid-item" :class="{'animate__show': isActive}">
          <img src="../assets/glasses-scene1.png" alt="Usage Scene">
        </div>
        <div class="grid-item" :class="{'animate__show': isActive}">
          <img src="../assets/glasses-scene2.png" alt="Usage Scene">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section4',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.section-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
  overflow: hidden;
}

.content-wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 8%;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  width: 100%;
}

.grid-item {
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  aspect-ratio: 16/9;
  opacity: 0;
  transform: scale(0.9);
  transition: all 0.8s ease;
  box-shadow: 0 0 20px rgba(66,185,131,0.1);
}

.grid-item.animate__show {
  opacity: 1;
  transform: scale(1);
}

.grid-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.grid-item:hover img {
  transform: scale(1.05);
}

.grid-item:nth-child(1) { transition-delay: 0s; }
.grid-item:nth-child(2) { transition-delay: 0.2s; }
.grid-item:nth-child(3) { transition-delay: 0.4s; }
.grid-item:nth-child(4) { transition-delay: 0.6s; }

@media screen and (max-width: 768px) {
  .section-content {
    height: auto;
    padding: 10px 0;
  }

  .content-wrapper {
    padding: 0 32px;
  }

  .grid-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .grid-item {
    aspect-ratio: 16/10;
  }

  .grid-item:nth-child(1) { transition-delay: 0s; }
  .grid-item:nth-child(2) { transition-delay: 0.15s; }
  .grid-item:nth-child(3) { transition-delay: 0.3s; }
  .grid-item:nth-child(4) { transition-delay: 0.45s; }
}
</style> 